/* eslint-disable max-lines-per-function */
import { Reducer } from 'redux';

import {
  SetAnalyticsSettingsRetentionCardCollapsed,
  SetAnalyticsSettingsSelectNetworkTimeframe,
  SetAnalyticsSettingsSelectNetworkTopThreadStarterSenderFilter,
  SetAnalyticsSettingsSelectTopNetworkAnnouncementSortOrder,
  SetAnalyticsSettingsSelectTopNetworkGroupSortOrder,
  SetAnalyticsSettingsSelectTopNetworkThreadSortOrder,
  SetAnalyticsSettingsSelectedUserAction,
} from '../../domains/analyticsSettings/actions.types';

import { defaultAnalyticsSettings } from './mock';
import { AnalyticsSettings } from './types';

export type AnalyticsSettingsAction =
  | SetAnalyticsSettingsSelectedUserAction
  | SetAnalyticsSettingsSelectNetworkTimeframe
  | SetAnalyticsSettingsSelectNetworkTopThreadStarterSenderFilter
  | SetAnalyticsSettingsSelectTopNetworkAnnouncementSortOrder
  | SetAnalyticsSettingsSelectTopNetworkGroupSortOrder
  | SetAnalyticsSettingsSelectTopNetworkThreadSortOrder
  | SetAnalyticsSettingsRetentionCardCollapsed;

const initialState = defaultAnalyticsSettings;

const reducer: Reducer<AnalyticsSettings, AnalyticsSettingsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'ANALYTICS_SETTING_SELECTED_USER.SET':
      return { ...state, selectedOnBehalfOfUserId: action.payload.selectedOnBehalfOfUserId };
    case 'ANALYTICS_SETTING_SELECT_NETWORK_TIMEFRAME.SET':
      return {
        ...state,
        networkActivitySettings: { ...state.networkActivitySettings, timeframe: action.payload.timeframe },
      };
    case 'ANALYTICS_SETTING_SELECT_NETWORK_TOP_THREAD_STARTER_SENDER_FILTER.SET':
      return {
        ...state,
        networkActivitySettings: {
          ...state.networkActivitySettings,
          topThreadStarterSenderFilter: action.payload.filterBy,
        },
      };
    case 'ANALYTICS_SETTING_SELECT_TOP_NETWORK_ANNOUNCEMENT_SORT_ORDER.SET':
      return {
        ...state,
        networkActivitySettings: {
          ...state.networkActivitySettings,
          topNetworkAnnouncementSortOrder: action.payload.sortOrder,
        },
      };
    case 'ANALYTICS_SETTING_SELECT_TOP_NETWORK_GROUP_SORT_ORDER.SET':
      return {
        ...state,
        networkActivitySettings: {
          ...state.networkActivitySettings,
          topNetworkGroupSortOrder: action.payload.sortOrder,
        },
      };
    case 'ANALYTICS_SETTING_SELECT_TOP_NETWORK_THREAD_SORT_ORDER.SET':
      return {
        ...state,
        networkActivitySettings: {
          ...state.networkActivitySettings,
          topNetworkThreadSortOrder: action.payload.sortOrder,
        },
      };
    case 'ANALYTICS_SETTING_RETENTION_CARD_COLLAPSED.SET':
      return {
        ...state,
        networkActivitySettings: {
          ...state.networkActivitySettings,
          isRetentionCardCollapsed: action.payload.isCollapsed,
        },
      };
    default:
      return state;
  }
};

export default reducer;
